class FeaturesWithSpecs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.carousel = new Swiper(this.querySelector('.swiper'), {
      navigation: {
        prevEl: this.querySelector('.swiper-arrow--prev'),
        nextEl: this.querySelector('.swiper-arrow--next'),
      },
      pagination: {
        el: this.querySelector('[data-pagination]'),
        type: 'bullets',
        clickable: true,
        dynamicBullets: true,
      },
      centeredSlides: true,
      slidesPerView: 1,
      spaceBetween: 8,
      breakpoints: {
        750: {
          spaceBetween: 20,
        },
      },
    });
  }
}

customElements.define('features-with-specs', FeaturesWithSpecs);
